<h1 mat-dialog-title class="aza-pa-dialog-title">{{ data.dialogTitleTranslationKey | translate }}</h1>

<div mat-dialog-content class="aza-pa-dialog-content">
  <div class="options aza-pa-flex-row">
    @if (!data.hideCreateFromTemplate) {
      <div (click)="onFromTemplateSelected()"
        class="option-box aza-pa-flex-column aza-pa-padding mat-elevation-z2 cursor-hand">
        <div class="icon-container">
          <mat-icon class="aza-pa-icon-big" color="primary">style</mat-icon>
        </div>
        <p class="option-text" translate>CREATE_FROM_TEMPLATE</p>
      </div>
    }
    @if (data.showPresets) {
      <div (click)="onFromPredefinedSelected()"
        class="option-box aza-pa-flex-column aza-pa-padding mat-elevation-z2 cursor-hand">
        <div class="icon-container">
          <mat-icon class="aza-pa-icon-big" color="primary">build</mat-icon>
        </div>
        <p class="option-text" translate>CREATE_FROM_PRESET</p>
      </div>
    }
    @if (!data.hideCreateFromScratch) {
      <div (click)="onFromScratchSelected()"
        class="option-box aza-pa-flex-column aza-pa-padding mat-elevation-z2 cursor-hand">
        <div class="icon-container">
          <mat-icon class="aza-pa-icon-big" color="primary">extension</mat-icon>
        </div>
        <p class="option-text" translate>CREATE_FROM_SCRATCH</p>
      </div>
    }
    @if (data.showImport) {
      <div (click)="onFromFileSelected()"
        class="option-box aza-pa-flex-column aza-pa-padding mat-elevation-z2 cursor-hand">
        <div class="icon-container">
          <mat-icon class="aza-pa-icon-big" color="primary">upload</mat-icon>
        </div>
        <p class="option-text" translate>{{translations.IMPORT_FROM_FILE}}</p>
      </div>
    }
  </div>
</div>
